<template>
  <div class="empty--item flex items-center w-full">
    <div class="flex items-center">
      <zt-icon name="file-outline" class="text-zt-xl" />
      <p class="pl-3 pt-1">
        {{ $t("message.myTeam.noFilesFound") }}
      </p>
      <zt-icon name="arrow-right-outline" class="ml-auto" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnsignedEmptyState',
  props: ['showDocument', 'windowWidth'],
  created() {
    if (this.windowWidth > 1024) {
      this.showDocument({})
    }
  }
}
</script>

<style lang="scss" scoped></style>
